import axios from 'axios'

// 为admin API创建一个新的axios实例，直接指向后端API地址
const adminService = axios.create({
  baseURL: 'https://tory.ffdzheng.com/api', // 直接指向后端API地址
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
adminService.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('admin-token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('Admin API Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
adminService.interceptors.response.use(
  response => {
    // 对响应数据做些什么
    return response.data
  },
  error => {
    // 对响应错误做些什么
    console.error('Admin API Response error:', error.response || error.message)
    
    // 处理401未授权错误 - 仅当不是测试token请求时才跳转登录
    if (error.response && error.response.status === 401) {
      const url = error.config?.url || ''
      // 如果是获取数据的API请求导致401，不立即跳转，而是返回错误信息让页面处理
      if (url.includes('/admin/')) {
        console.log('Admin API 401错误，返回错误信息而不是跳转登录:', url)
        return Promise.reject(error)
      } else {
        // 其他情况仍然跳转到登录页
        localStorage.removeItem('admin-token')
        localStorage.removeItem('admin-info')
        window.location.href = '/#/login'
      }
    }
    
    return Promise.reject(error)
  }
)

export default adminService
